var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAssign = function SvgIconAssign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-98.5,12a1,1,0,0,1-1,1,1,1,0,0,1-1-1,1,1,0,0,1,1-1A1,1,0,0,1-98.5,12ZM-88,5.946a1,1,0,0,0-1.351-.417,1,1,0,0,0-.418,1.351A10.862,10.862,0,0,1-88.5,12a10.862,10.862,0,0,1-1.269,5.12,1,1,0,0,0,.418,1.352,1,1,0,0,0,.466.115A1,1,0,0,0-88,18.054,13.029,13.029,0,0,0-86.5,12,13.032,13.032,0,0,0-88,5.946Zm-4.889,1.445a1,1,0,0,0-.418,1.351A6.912,6.912,0,0,1-92.5,12a6.9,6.9,0,0,1-.808,3.258,1,1,0,0,0,.419,1.351.989.989,0,0,0,.465.116,1,1,0,0,0,.886-.534A9.027,9.027,0,0,0-90.5,12a9.01,9.01,0,0,0-1.039-4.191A1,1,0,0,0-92.889,7.391Zm-3.554,1.87a1,1,0,0,0-.417,1.351A2.958,2.958,0,0,1-96.5,12a2.958,2.958,0,0,1-.36,1.388,1,1,0,0,0,.417,1.351,1,1,0,0,0,.466.115,1,1,0,0,0,.885-.533A4.925,4.925,0,0,0-94.5,12a4.925,4.925,0,0,0-.592-2.321A1,1,0,0,0-96.443,9.261Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAssign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-assign.237f372d.svg";
export { ForwardRef as ReactComponent };